import React from "react";
import Authors from "../../../../atoms/author";
import { format } from "date-fns";

const DhExclusiveAuthors = ({ story }) => {
  const isBrandspotNoAdStory = story["story-template"] === "brandspot-with-no-ad";
  const isSponsoredStory = story["story-template"] === "sponsored";
  const isBrandspotClientStory = story["story-template"] === "brandspot-client-story";
  const lastUpdatedDateAndTime = format(new Date(story && story["last-published-at"]), "dd MMMM yyyy, HH:mm");

  if (isBrandspotNoAdStory || isSponsoredStory || isBrandspotClientStory) return null;
  return (
    <div>
      <Authors
        authors={story.authors}
        clazzName="author-name-image"
        lastUpdatedDateAndTime={lastUpdatedDateAndTime}
        isDHExclusive={true}
      />
    </div>
  );
};

export default DhExclusiveAuthors;
